import { columns } from '@ipc/ipc-components';
import column from '../../../../common/list-table/helpers/columns';

export default (data, userRole = '', onRowEdit) => {
  const {
    TextColumn,
    DateTimeColumn,
  } = columns(data);
  const { ActionColumn, FilteredNullableBooleanColumn } = column(data);

  const ipcUserRoles = ['IPC_ADMIN', 'IPC_VIEWER'];
  const isUserIpcRole = ipcUserRoles.includes(userRole);
  const isUserIPCAdmin = userRole === 'IPC_ADMIN';
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Country', 'country'),
        new TextColumn('MRD name', 'mrdName'),
        new TextColumn('Device type', 'deviceType.description'),
        new TextColumn('MRD status', 'mrdStatus.description'),
        new FilteredNullableBooleanColumn('Physical MRD', 'physicalMrd'),
        new TextColumn('IMPC', 'impc'),
        new TextColumn('Airport (IATA)', 'airport'),
        new TextColumn('Operator', 'operator'),
        new TextColumn('MAC address', 'macAddress').withWidth(150),
        new TextColumn('Kiosk model', 'kioskModel'),
        new TextColumn('Printer model', 'printerModel'),
        new TextColumn('Scanner model', 'scannerModel'),
        new TextColumn('Team Viewer ID', 'teamViewerId').withShow(isUserIpcRole),
        new TextColumn('Data Location', 'dataLocation'),
        new DateTimeColumn('First operation', 'firstOperation').withWidth(140),
        new DateTimeColumn('Last modified time', 'lastModifiedTime').withWidth(140),
        new ActionColumn([['EDIT', 'mrdName', onRowEdit, isUserIPCAdmin]]).withShow(isUserIPCAdmin),
      ],
    },
  ];
};
